<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-17 14:30:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/addresslist/components/AddressItem/index.vue
 -->
<template>
  <div class="add_list" @click.stop="clickAddressItem(rows)">
    <div class="add_content">
      <!-- 第一行：默认标签 + 省市区 -->
      <div class="row_1">
        <span
          v-if="rows.isDefault"
          class="default_icon font10 font_weight400 line_height_14"
          >默认</span
        >
        <span class="address_title line_height_18">
          {{ rows.country ? rows.country + " " : "" }}{{ rows.province }}
          {{ rows.city }} {{ rows.district }}
        </span>
      </div>

      <!-- 第二行：详细地址 -->
      <div class="address_detail line_height_22">
        {{ rows.addressLine }}
      </div>

      <!-- 第三行：姓名 电话 -->
      <div class="user_info line_height_17">
        {{ rows.name }} {{ rows.phone }}
      </div>
    </div>
    <img
      src="@/assets/common/icon_edit_outline_24@2x.png"
      alt="编辑"
      @click.stop="editAddress(rows.id)"
    />
  </div>
</template>

<script>
export default {
  props: {
    rows: {
      type: Object,
      default() {
        return {};
      }
    },
    rowIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    editAddress(id) {
      this.$emit("editAddress", id, this.rowIndex);
    },
    clickAddressItem(rows) {
      this.$emit("clickAddressItem", rows);
    }
  }
};
</script>

<style lang="less" scoped>
.add_list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: #ffffff;
  border-radius: 6px;
  margin: 10px 12px 0 12px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.02);

  img {
    width: 24px;
    height: 24px;
    padding: 5px;
    cursor: pointer;
    flex-shrink: 0;
  }

  .add_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 10px;
    overflow: hidden;

    .row_1 {
      display: flex;
      align-items: flex-start;
      margin-bottom: 6px;
      width: 100%;
      text-align: left;

      .default_icon {
        display: inline-block;
        padding: 1px 4px;
        background: rgba(182, 112, 28, 0.15);
        color: #b6701c;
        border-radius: 2px;
        margin-right: 10px;
        flex-shrink: 0;
        margin-top: 2px;
      }

      .address_title {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        flex: 1;
        word-break: break-all;
        text-align: left;
      }
    }

    .address_detail {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      margin-bottom: 6px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      word-break: break-all;
      text-align: left;
    }

    .user_info {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      text-align: left;
    }
  }
}
</style>
